// Concept-question expansion for the info-view compare-items block, ported from the coffee view
// (calcConceptQuestions). Every selected item becomes a synthetic question built from the block
// template: `$name` placeholders resolve against the batch, `@name` against the batch answer.

const PLACEHOLDER = /\$[\d\w]+/
const WHOLE_PLACEHOLDER = /^\$[\d\w]+$/

const resolveSchemaValue = (value, batch, answer) => {
  if ('string' !== typeof value) return value
  if (WHOLE_PLACEHOLDER.test(value)) return batch[value.slice(1)]
  if (PLACEHOLDER.test(value)) {
    return value.replaceAll(new RegExp(PLACEHOLDER, 'g'), match => batch[match.slice(1)])
  }
  if ('@' === value[0]) return answer[value.slice(1)]

  return value
}

const calcBlocks = (template, batch, answer) =>
  template.blocks.map(block =>
    Object.keys(block).reduce((schema, key) => {
      schema[key] = resolveSchemaValue(block[key], batch, answer)
      return schema
    }, {})
  )

export const calcConceptQuestions = ({
  template,
  batches = [],
  answer = {},
  items = [],
  itemIndexes = [],
  questionId,
  questionKey
} = {}) => {
  if (!template?.blocks?.length) return null

  const questions = []

  for (const [i, index] of [...new Set(itemIndexes)].entries()) {
    const batch = batches.find(b => b.position === items[index]?.position)
    if (!batch) continue

    const batchAnswer = answer[`b${batch.position}`] || {}

    questions.push({
      answer: batchAnswer,
      answers_randomize: template.answers_randomize,
      blocks: calcBlocks(template, batch, batchAnswer),
      id: `${questionId}_${batch.position}`,
      key: `${questionId}_${batch.position}`,
      position: 0,
      visual_position: i + 1,
      parentID: questionId,
      parentKEY: questionKey,
      last_pq: template.last_pq,
      subquestions_randomize: template.subquestions_randomize,
      text: template.text,
      type: template.type,
      path: [`b${batch.position}`]
    })
  }

  return questions
}
